<!--档案管理-->
<template>
    <div class="studio_nav_content">
        <!--列表模式-->
        <div class="page-mode" v-if="showMode==='list'">
            <div class="model-container">
                <div :class="activeItem==='1'?'model-item model-active':'model-item'" @click="handleActiveChange('1')">教学分析报告</div>
            </div>
            <!--报告列表-->
            <div class="bre9e" v-show="activeItem==='1'">
                <el-table header-cell-class-name="bgf2" show-overflow-tooltip
                          height="calc(100vh - 232px)"
                          :data="dataList"
                          highlight-current-row>
                    <el-table-column type="index" align="center" label="序号" width="60" />
                    <el-table-column width="80" align="center" label="状态" prop="taskStatus">
                        <template #default="scope">
                            <div v-if="scope.row.taskStatus === '0'">待分析</div>
                            <div v-if="scope.row.taskStatus === '1'">分析中</div>
                            <div v-if="scope.row.taskStatus === '2'">已分析</div>
                            <div v-if="scope.row.taskStatus === '-1'">分析失败</div>
                        </template>
                    </el-table-column>
                    <el-table-column width="140" align="center" label="操作时间" prop="Time">
                        <template #default="scope">
                            <div>{{ timestampToTime(scope.row.createTime)}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column  align="center" label="操作人" prop="createUserName"></el-table-column>
                    <el-table-column width="160"  align="center" label="视频名称" prop="taskName" ></el-table-column>
                    <el-table-column  align="center" label="授课教师" prop="trueName"></el-table-column>
                    <el-table-column  align="center" label="学段" prop="periodName"></el-table-column>
                    <el-table-column  align="center" label="学科" prop="subjectName"></el-table-column>
                    <el-table-column width="160"  align="center" label="量表" prop="scaleName"></el-table-column>
                    <el-table-column fixed="right" width="120" label="操作" align="center">
                        <template #default="scope">
                            <el-button v-if="scope.row.taskStatus==='2'" type="primary" size="small" @click="handleDetail(scope.row)">查看报告</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>

        <!-- 报告详情 -->
        <div class="detail-mode" v-if="showMode==='reportInfo'">
            <report-info  :info-id="this.taskId"
                          @change-active-mode="changeActiveModel"/>
        </div>
    </div>
</template>

<script>
import {timestampDate, timestampToTime} from "@/utils/date";
import {listUserReport} from "@/api/admin/courseAnalyse";
import reportInfo from "@/components/homeManager/report/reportInfo.vue";
import archiveCheck from "@/components/homeManager/archive/archiveCheck.vue";

export default {
    name:'userAnalyseReport',
    computed: {},
    components:{
        archiveCheck,
        reportInfo,
    },
    props:{
        itemMode:{
            type: String,
            default:'page'
        },
    },
    watch:{
        itemMode(newValue,oldValue){
            this.showMode = newValue;
        },
    },
    mounted() {
        this.geUserReportList();
    },
    data() {
        return {
            listMode:'list',
            infoMode:'reportInfo',
            showMode:'list',
            activeItem:'1',
            timestampDate,
            timestampToTime,
            userId:JSON.parse(this.$storage.get("userInfo")).userId,
            dataList:[],
            taskId:'',
        }
    },
    methods: {
        geUserReportList(){
            listUserReport().then(res => {
                if (res.data.code===1){
                    this.dataList = res.data.data;
                }else {
                    this.$message.error(res.data.msg);
                }
            })
        },
        handleActiveChange(activeItem){
            this.activeItem = activeItem;
            this.geUserReportList()
        },
        //子组件传值
        changeActiveModel(model,activeItem){
            this.showMode = model;
            this.activeItem = activeItem;
            this.$emit('change-mode',this.showMode, 1);
            if (activeItem==='1'){
                this.geUserReportList()
            }
        },
        handleDetail(row){
            this.taskId = row.taskId
            this.showMode = this.infoMode;
            this.$emit('change-mode',this.infoMode);
        }
    }
}

</script>

<style scoped>
.studio_nav_content{
    width: 100%;
    height: auto;
    //font-family: "黑体",serif;
}
.page-mode{
    width: 100%;
    height: auto;
    background-color: #fff;
}
.model-container{
    width: 100%;
    height: 50px;
    display: flex;
    padding-left: 10px;
    box-sizing: border-box;
    border-bottom: 1px solid #ff7f2e;
}
.model-item{
    width: auto;
    padding: 0 10px 0 10px;
    height: 28px;
    color: #ff7f2e;
    border: 1px solid #ff7f2e;
    line-height: 28px;
    margin-right: 20px;
    font-size: 14px;
    border-radius: 6px;
    margin-top: 11px;
    cursor: pointer;
    font-weight: bold;
}
.model-active{
    color: #fff!important;
    border: 1px solid #ff7f2e!important;
    background-color: #ff7f2e!important;
}


.tab-dfp{
    width: 60px;
    height: 24px;
    font-size: 12px;
    border-radius: 12px;
    font-weight: bold;
    color: #fff;
    text-align: center;
    line-height: 24px;
    background-color: #ffbf6b
}
.tab-dsh{
    width: 60px;
    height: 24px;
    font-size: 12px;
    border-radius: 12px;
    font-weight: bold;
    color: #fff;
    text-align: center;
    line-height: 24px;
    background-color: #4095e5
}
.tab-shtg{
    width: 60px;
    height: 24px;
    font-size: 12px;
    border-radius: 12px;
    font-weight: bold;
    color: #fff;
    text-align: center;
    line-height: 24px;
    background-color: #81b337;
}
.tab-shjj{
    width: 60px;
    height: 24px;
    font-size: 12px;
    border-radius: 12px;
    font-weight: bold;
    color: #fff;
    text-align: center;
    line-height: 24px;
    background-color: #bd3124;
}

.status-info-bm{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #4095e5;
    font-size: 12px;
    text-align: center;
    color: #fff;
    text-indent: 0!important;
}
.status-info-kt{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #ffbf6b;
    font-size: 12px;
    text-align: center;
    color: #fff;
    text-indent: 0!important;
}
.status-info-zq{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #bd3124;
    font-size: 12px;
    text-align: center;
    color: #fff;
    text-indent: 0!important;
}
.status-info-jt{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #81b337;
    font-size: 12px;
    text-align: center;
    color: #fff;
    text-indent: 0!important;
}
</style>